import { lazy, Suspense, type ComponentType } from "react";
import { Center } from "@astryxdesign/core/Center";
import { Spinner } from "@astryxdesign/core/Spinner";
import { useT } from "@/lib/i18n";

/** Code-split screen with a loading state (never a blank page). */
export function lazyScreen<P extends object>(load: () => Promise<ComponentType<P>>) {
  const Lazy = lazy(async () => ({ default: await load() }));
  return function LazyScreen(props: P) {
    const t = useT();
    return (
      <Suspense
        fallback={
          <Center height="60dvh">
            <Spinner size="lg" label={t.common.loading} />
          </Center>
        }
      >
        <Lazy {...props} />
      </Suspense>
    );
  };
}
